import areArrayOfIdsEqual from '$utils/areArrayOfIdsEqual';
import isArrayEmpty from './isArrayEmpty';

const normalize = (v) => (Array.isArray(v) ? v : []);

const areAssignmentMappingsEqual = (a = [], b = []) =>
  JSON.stringify(a) === JSON.stringify(b);

const checkSaveDisabled = ({
  selectedAssignments,
  mappedAssignments,
  selectedAssessmentItems,
  linkedAssessments,
}) => {
  const leftLinked = normalize(linkedAssessments);
  const rightLinked = normalize(selectedAssessmentItems);

  const leftMapped = normalize(mappedAssignments);
  const rightMapped = normalize(selectedAssignments);

  // If no mapped assignments
  if (isArrayEmpty(leftMapped)) {
    const linkedItemsAreEqual = areArrayOfIdsEqual(
      leftLinked,
      rightLinked,
      true
    );
    if (!linkedItemsAreEqual) return false;
    return isArrayEmpty(rightMapped);
  }

  const linkedItemsAreEqual = areArrayOfIdsEqual(leftLinked, rightLinked, true);
  const mappedAreEqual = areAssignmentMappingsEqual(leftMapped, rightMapped);

  if (!linkedItemsAreEqual || !mappedAreEqual) return false;

  return true;
};

export default checkSaveDisabled;
